import store from '../store'

// eslint-disable-next-line no-return-await
const requestPermission = async () => await Notification.requestPermission()

const notificationService = async (body, silent, url) => {
  const currentUser = await store.dispatch('appAuth/getCurrentUser')
  const permission = await requestPermission()
  
  if (permission && currentUser.role === 'admin') {
    const notification = new Notification("Hoiwa", {
      body,
      icon: 'https://i.ibb.co/0fphfpk/Hoiwa-Tunnus-V-3.png',
      silent,
    })

    notification.addEventListener('click', () => {
      window.open(url, '_blank')
    })
  }
}

export {notificationService, requestPermission}
